import { Environment } from '@interfaces/environment';

export const environment: Environment = {
  production: false,
  dynamic: true
};
